export default __webpack_public_path__ + "static/media/grubdash_screen_large.64c1dc3b.png";